const TIPOS_FILTER_MULTIPLE = [
  { NombreTag: 'metadatos', Required: ['campo', 'valor'] }
]

const TIPOS_FILTER_LABEL = [
  { NombreTag: 'Archivado', label: '' }
]

export {
  TIPOS_FILTER_MULTIPLE,
  TIPOS_FILTER_LABEL
}
